import { OwnerQueueView } from './OwnerQueueView';

// SQA-66: Nate — Production Questions queue.
export function NateQueue(): JSX.Element {
  return (
    <OwnerQueueView
      slug="nate-production-question"
      displayName="Nate — Production Questions"
      roleKey="production"
    />
  );
}
